export const GET_CURRENT_USER_START = 'GET_CURRENT_USER_START';
export const GET_CURRENT_USER_END = 'GET_CURRENT_USER_END';
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS';
export const GET_CURRENT_USER_FAILURE = 'GET_CURRENT_USER_FAILURE';
